import React from 'react';

import { Skeleton, Stack } from '@mantine/core';
import { IconLock } from '@tabler/icons-react';
import { useAuth } from 'context/auth-context';
import dayjs from 'dayjs';
import useTotalUncreditedReservations from 'hooks/reports/reservations/uncredited-reservations/useTotalUncreditedReservations';
import { useNavigate } from 'react-router-dom';

interface Props {
  gridAreaClass: string;
  clickableCardClass?: string;
  labelClass: string;
  valueClass: string;
}

export const TotalUncreditedReservations: React.FC<Props> = ({
  gridAreaClass,
  clickableCardClass,
  labelClass,
  valueClass,
}) => {
  const navigate = useNavigate();
  const { hasPerm } = useAuth();
  const isViewable = hasPerm('ReservationsReportView');

  const startDate = dayjs().format('YYYY-MM-DD');
  const endDate = dayjs().add(6, 'day').format('YYYY-MM-DD');

  const { data, isLoading, isError, isSuccess } = useTotalUncreditedReservations({ startDate, endDate });

  const handleClick = (): void => {
    if (isViewable) navigate('/reports/uncredited-reservations');
  };

  const renderContent = (): React.JSX.Element | null => {
    if (!isViewable) return <IconLock size='2rem' />;
    if (isLoading) return <Skeleton height='2rem' width='75%' />;
    if (isError) return <div className={valueClass}>Error</div>;
    if (isSuccess && data) return <div className={valueClass}>{data.data.total}</div>;
    return null;
  };

  return (
    <Stack
      spacing={0}
      p='xs'
      className={`${gridAreaClass} ${isViewable ? clickableCardClass : ''}`}
      onClick={handleClick}
    >
      <div className={labelClass}>
        <Stack spacing={0}>
          <div>Total</div>
          <div>uncredited reservations</div>
        </Stack>
      </div>
      {renderContent()}
    </Stack>
  );
};
